import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import teczLogo from '../Assets/teczo.png';
import './Navbar.css';

const NAV_ITEMS = [
  { label: 'Home',     route: '/' },
  { label: 'About Us', route: '/about' },
  { label: 'Solutions',route: '/solutions' },
  { label: 'Products', route: '/products' },
];

const Navbar = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled]     = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setMobileOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const go = (route) => { navigate(route); setMobileOpen(false); };

  return (
    <div
      className="ew-nav"
      ref={navRef}
      style={{ boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.06)' : 'none' }}
    >
      <div className="ew-nav__inner">
        {/* Brand */}
        <NavLink to="/" className="ew-nav__brand" onClick={() => setMobileOpen(false)}>
          <img src={teczLogo} alt="Teczo" className="ew-nav__logo-img" />
          <span className="ew-nav__brand-divider">|</span>
          <div>
            <div className="ew-nav__brand-name">EnergyWorks</div>
            <div className="ew-nav__brand-sub">Teczo Subsidiary</div>
          </div>
        </NavLink>

        {/* Desktop Nav Links */}
        <div className="ew-nav__links">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.route}
              to={item.route}
              end={item.route === '/'}
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        {/* Desktop CTA */}
        <NavLink to="/contact" className="ew-nav__cta">
          Let's Collaborate
        </NavLink>

        {/* Hamburger */}
        <button
          className="ew-nav__hamburger"
          onClick={() => setMobileOpen(o => !o)}
          aria-label="Toggle menu"
        >
          {mobileOpen
            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          }
        </button>
      </div>

      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="ew-nav__mobile-menu">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.route}
              to={item.route}
              end={item.route === '/'}
              className={({ isActive }) => `ew-nav__mobile-link${isActive ? ' ew-nav__mobile-link--active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <div className="ew-nav__mobile-cta-wrap">
            <button className="ew-nav__mobile-cta" onClick={() => go('/contact')}>
              Let's Collaborate
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
